import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from "./core/home/home.component";
import { MsalGuard } from "@azure/msal-angular";
import { MessageComponent } from "./pages/traffic-information/message/message.component";
import { UserInfoComponent } from "./pages/user-info/user-info.component";
import { RestrictedComponent } from "./pages/restricted/restricted.component";
import { TrafficInformationComponent } from "./pages/traffic-information/traffic-information.component";
import { ContactsComponent } from "./pages/phonebook/contacts/contacts.component";
import { CategoriesComponent } from "./pages/phonebook/categories/categories.component";
import { rejectDirtyFormGuard } from "./guards/reject-dirty-form.guard";
import { TrainOrdersComponent } from "./pages/train-orders/train-orders.component";
import { AlcolockComponent } from "./pages/alcolock/alcolock.component";
import { TurnReportsComponent } from "./pages/turanmalningar/turanmalningar.component";
import { DriverDeviationsComponent } from "./pages/driver-deviations/driver-deviations.component";
import { AlcolockAccessGuard } from './guards/alcolock-access.guard';
import { DriverDeviationAccessGuard } from './guards/driver-deviation-access.guard';

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    pathMatch: "full",
    canActivate: [MsalGuard]
  },
  {
    path: "trafikinfo",
    component: TrafficInformationComponent,
    pathMatch: "full",
    canActivate: [MsalGuard],
    canDeactivate: [rejectDirtyFormGuard]
  },
  {
    path: "trafikinfo/:messageId",
    component: TrafficInformationComponent,
    pathMatch: "full",
    canActivate: [MsalGuard],
    canDeactivate: [rejectDirtyFormGuard]
  },
  {
    path: "kontakter",
    component: ContactsComponent,
    pathMatch: "full",
    canActivate: [MsalGuard],
    canDeactivate: [rejectDirtyFormGuard],
  },
  {
    path: "kategorier",
    component: CategoriesComponent,
    pathMatch: "full",
    canActivate: [MsalGuard],
    canDeactivate: [rejectDirtyFormGuard],
  },
  {
    path: "tagorder",
    component: TrainOrdersComponent,
    pathMatch: "full",
    canActivate: [MsalGuard]
  },
  {
    path: "alcolock/roda-blasningar",
    component: AlcolockComponent,
    canActivate: [MsalGuard, AlcolockAccessGuard],
    canDeactivate: [rejectDirtyFormGuard],
  },
  {
    path: "alcolock/turanmalningar",
    component: TurnReportsComponent,
    canActivate: [MsalGuard, AlcolockAccessGuard],
  },
  {
    path: "alcolock",
    redirectTo: "alcolock/roda-blasningar",
    pathMatch: "full"
  },
  {
    path: "foraravvikelser",
    component: DriverDeviationsComponent,
    pathMatch: "full",
    canActivate: [MsalGuard, DriverDeviationAccessGuard]
  },
  {
    path: "trafikinfoPopup/:id",
    component: MessageComponent,
    canActivate: [MsalGuard],
    canDeactivate: [rejectDirtyFormGuard]
  },
  {
    path: "signin-oidc",
    component: UserInfoComponent
  },
  {
    path: "restrictionTest",
    component: TrafficInformationComponent,
    canActivate: [MsalGuard],
    canDeactivate: [rejectDirtyFormGuard]
  },
  {
    path: "restricted",
    component: RestrictedComponent,
    canActivate: []
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
